import { render, staticRenderFns } from "./EditBookingCategory.vue?vue&type=template&id=6603ce56&scoped=true&"
import script from "./EditBookingCategory.vue?vue&type=script&lang=js&"
export * from "./EditBookingCategory.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=6603ce56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603ce56",
  null
  
)

export default component.exports